import { BasicQueryIcon } from './BasicQueryIcon.jsx';
import { ProQueryIcon } from './ProQueryIcon.jsx';

/**
 * Hero sağ kolon — Basit Sorgu / ProSorgu neon modül kartları.
 * @param {{ item: { label: string, desc: string, href: string }, variant: 'basic' | 'pro' }} props
 */
export function HeroQueryCard({ item, variant }) {
  const isPro = variant === 'pro';
  const cardClass = [
    'pp-landing-hero-capabilities__card',
    'pp-landing-hero-capabilities__card--quick',
    'query-card',
    isPro ? 'query-card-pro' : 'query-card-basic',
  ].join(' ');

  return (
    <a class={cardClass} role="listitem" href={item.href}>
      {!isPro ? (
        <span class="query-card__pill query-card__pill--free" aria-label="Ücretsiz">
          ÜCRETSİZ
        </span>
      ) : null}
      <div class="query-card__head">
        <strong>{item.label}</strong>
      </div>
      <div class="query-icon" aria-hidden="true">
        <span class="query-icon__anim">
          {isPro ? <ProQueryIcon /> : <BasicQueryIcon />}
        </span>
      </div>
      <div class="query-card__body">
        <p>{item.desc}</p>
      </div>
      <span class="pp-landing-hero-capabilities__arrow" aria-hidden="true">›</span>
    </a>
  );
}
